declare var window: any;

export const pageView = (path: string, pageTitle: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'Pageview', path, pageTitle });
};

export const sendEvent = (isLink: boolean, label: string, category = 'onboardingBP') => {
    const action = isLink ? 'link' : 'message';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'gtmUAEvent', action, label, category });
};
